import { render, staticRenderFns } from "./PBDRangeSelector.vue?vue&type=template&id=1219c116&scoped=true&"
import script from "./PBDRangeSelector.vue?vue&type=script&lang=js&"
export * from "./PBDRangeSelector.vue?vue&type=script&lang=js&"
import style0 from "./PBDRangeSelector.vue?vue&type=style&index=0&id=1219c116&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1219c116",
  null
  
)

export default component.exports